export const otpValidator = (v) => {
  if (!v || v.length < 6) return "Please enter the complete 6-digit code";
  return null;
};

const INVALID_OTP_PHRASES = ["invalid activation token", "invalid token"];
export const isInvalidOtpMessage = (msg) => {
  const lower = msg.toLowerCase();
  return INVALID_OTP_PHRASES.some((phrase) => lower.includes(phrase));
};

export function applyOtpBlock(errorResponse, store) {
  const parsed = errorResponse.headers["date"]
    ? new Date(errorResponse.headers["date"]).getTime()
    : Number.NaN;
  const serverTimestamp = Number.isNaN(parsed) ? Date.now() : parsed;
  store.getState().setOtpBlock(serverTimestamp + 5 * 60 * 1000);
}
